<template>
	<div class="modal-info">
		<div v-if="oportunidadesEmBreve" class="d-flex justify-content-center align-items-center dashboard">
			<div class="dashboard__complete">
				<div class="row">
					<div class="col-12 text-center">
						<h1>Em breve novas oportunidades</h1>
					</div>
				</div>
			</div>
		</div>

		<div v-if="!oportunidadesEmBreve" class="row list-view">
			<!-- INICIO MODAL INVESTIMENTO -->
			<Modal
				v-if="showModal"
				@close="voltar()"
				:solicitacaoProps="solicitacao"
				:investidor="investidor"
				:usuario="User"
			/>
			<!-- TERMINO MODAL INVESTIMENTO -->

			<div class="col-12 tit_page">
				<div class="row align-items-center">
					<div class="col-12 col-lg-4 float-left">
						<h1>Oportunidades</h1>
					</div>
					<div class="col-12 col-lg-6 float-right text-lg-right">
						<div class="row">
							<div class="col-12 control-group">

								<strong>Score: </strong>
								<label class="control control-aa control-checkbox">
									AA
									<input id="AA" ref="AA" type="checkbox" checked="checked" v-on:click="scoreClick($event, 'AA')" />
									<div class="control_indicator"></div>
								</label>
								<label class="control control-a control-checkbox">
									A
									<input id="A" ref="A" type="checkbox" checked="checked" v-on:click="scoreClick($event, 'A')" />
									<div class="control_indicator"></div>
								</label>
								<label class="control control-b control-checkbox">
									B
									<input id="B" ref="B" type="checkbox" checked="checked" v-on:click="scoreClick($event, 'B')" />
									<div class="control_indicator"></div>
								</label>

								<label class="control control-c control-checkbox">
									C
									<input id="C" ref="C" type="checkbox" checked="checked" v-on:click="scoreClick($event, 'C')" />
									<div class="control_indicator"></div>
								</label>

								<label class="control control-d control-checkbox">
									D
									<input id="D" ref="D" type="checkbox" checked="checked" v-on:click="scoreClick($event, 'D')" />
									<div class="control_indicator"></div>
								</label>

								<label class="control control-e control-checkbox">
									E
									<input id="E" ref="E" type="checkbox" checked="checked" v-on:click="scoreClick($event, 'E')" />
									<div class="control_indicator"></div>
								</label>

								<label class="control control-hr control-checkbox">
									HR
									<input id="HR" ref="HR" type="checkbox" checked="checked" v-on:click="scoreClick($event, 'HR')" />
									<div class="control_indicator"></div>
								</label>

								<label class="control control-todos control-checkbox">
									Todos
									<input id="all" ref="all" type="checkbox" checked="checked" v-on:click="scoreAll($event)" />
									<div class="control_indicator"></div>
								</label>
							</div>
						</div>
					</div>
					<div class="col-12 col-lg-2 d-flex justify-content-end align-items-center display">
						<span>Exibir como</span>
						<ul class="display-loans">
							<li class="display-loan grid">
								<label for="grid">
									<input type="radio" name="loans" id="grid" value="grid" @click="setCards" :checked="showCards">
									<svg viewBox="0 0 19.2 19.2">
									    <g transform="translate(0.6 0.6)"><path d="M81.548,8.138a.334.334,0,0,1-.31.31H74.41a.334.334,0,0,1-.31-.31V1.31A.334.334,0,0,1,74.41,1h6.828a.334.334,0,0,1,.31.31Z" transform="translate(-74.1 -1)"/><path d="M115.548,8.138a.334.334,0,0,1-.31.31H108.41a.334.334,0,0,1-.31-.31V1.31a.334.334,0,0,1,.31-.31h6.828a.334.334,0,0,1,.31.31Z" transform="translate(-97.548 -1)"/><path d="M81.548,42.138a.334.334,0,0,1-.31.31H74.41a.334.334,0,0,1-.31-.31V35.31a.334.334,0,0,1,.31-.31h6.828a.334.334,0,0,1,.31.31Z" transform="translate(-74.1 -24.448)"/><path d="M115.548,42.138a.334.334,0,0,1-.31.31H108.41a.334.334,0,0,1-.31-.31V35.31a.334.334,0,0,1,.31-.31h6.828a.334.334,0,0,1,.31.31Z" transform="translate(-97.548 -24.448)"/></g>
									</svg>
								</label>
							</li>
							<li class="display-loan list">
								<label for="list">
									<input type="radio" name="loans" id="list" value="list" @click="unsetCards" :checked="showCards==''">
									<svg viewBox="0 0 19.2 19.2">
									    <g transform="translate(0.6 0.6)"><rect width="18" height="4.345" transform="translate(0)"/><rect width="18" height="4.345" transform="translate(0 6.828)"/><rect width="18"  height="4.345" transform="translate(0 13.655)"/></g>
									</svg>
								</label>
							</li>
						</ul>
					</div>
					<div class="clearfix"></div>
				</div>

				<hr class="divider">

				<!-- NOVOS CARDS PARA EXIBIÇÃO -->
				<div class="view" v-if="showCards">
					<div class="row cards">
						<div v-for="(item, index) in this.oportunidades" v-bind:key="item._id" :class=" 'column rating-' + lowerCase(item.Score)">
							<opportunityCard
								:index="index"
								:item="item"
								:mudarOportunidade="mudarOportunidade"
								:ajustIdOportunidade="ajustIdOportunidade"
								:formatarScore="formatarScore"
								:formatarTipoEmprestimo="formatarTipoEmprestimo"
								:money="money"
								:inteiro="inteiro"
								:levantado="levantado"
								:faltam="faltam"
								:diffDate="diffDate"
								:valor="valor"
								:templateRender="templateRender"
							/>
						</div>
					</div>
				</div>
				<!-- FINAL LISTA OPORTUNIDADES COMO CARDS MOBILE -->

				<opportunitiesList
					v-if="!showCards"
					:oportunidatesAux="oportunidades"
					:mudarOportunidade="mudarOportunidade"
					:ajustIdOportunidade="ajustIdOportunidade"
					:formatarScore="formatarScore"
					:formatarTipoEmprestimo="formatarTipoEmprestimo"
					:money="money"
					:inteiro="inteiro"
					:levantado="levantado"
					:faltam="faltam"
					:diffDate="diffDate"
					:valor="valor"
					:templateRender="templateRender"
					:lowerCase="lowerCase"
					:InvestidorBloqueado="InvestidorBloqueado()"/>
				
				<!-- FINAL LISTA OPORTUNIDADES TABELA -->

				<!-- INICIO PAGINAÇAO -->
				<Pagination
                    :paginasTotais="this.Paginas"
                    :paginaAtual="this.indexPage"
                    :navigate="(rota)=>this.paginacao(rota-1)"
                />
				<!-- FINAL PAGINAÇÃO -->
			</div>
		</div>
	</div>
</template>


<script>
	/* eslint-disable */
	import Modal from "@/components/NewModal/Modal";
	import OpportunityCard from "@/components/OpportunityCard";
	import OpportunitiesList from "@/components/OpportunitiesList";
	import Pagination from '@/components/Pagination';
	import * as mutationTypes from "@/store/mutation-types.js";
	import ApiClient from "@/utils/api-client";
	import ApiClientGo from "@/utils/api-client-go";
	import Masker from "@/utils/masker";
	import ArrayHelper from "@/utils/array-helper";

	export default {
		data() {
			return {
				showCards: sessionStorage.getItem('showCards') == '' ? false : true,
				showModal: false,
				oportunidades: [],
				scoreFiltrado:[],
				filterOportunidades: [],
				filterAux: [],
				investidor: {},
				indexPage: 1,
				Paginas:0,
				InvestorAprovado: false,
				oportunidadesEmBreve: false,
				temCadastroInvestidor: false,
				temSuitability: false,
				investidorAprovado: false,
				User:null,
				solicitacao: null,
				bloqueio:'',
				// Scores selecionados
				arrScore:["AA","A","B","C","D","E","HR"],
				// Scores removidos
				arrFiltroScore:[],
				strScoreFilter: [
					{
						"score": "AA",
						"status": true
					},
					{
						"score": "A",
						"status": true
					},
					{
						"score": "B",
						"status": true
					},
					{
						"score": "C",
						"status": true
					},
					{
						"score": "D",
						"status": true
					},
					{
						"score": "E",
						"status": true
					},
					{
						"score": "HR",
						"status": true
					}
				],
			};
		},
		methods: {
			// Requests
				async listaOportunidades(){
					try{
						this.$store.commit(mutationTypes.START_LOADING)

						let stringScore = this.arrScore.join("-")

						let resp = await ApiClientGo.ListarOportunidades(this.indexPage, stringScore)
						this.Paginas = resp.Paginas
						let oportunidades = this.TrataOportunidades(resp.ItemListagemSolicitacoes);
						
						if(oportunidades == null) {
							this.oportunidadesEmBreve = true
							return []
						}

						// Ordena Publicados
						let publicados = this.pegaPublicados(oportunidades)
						oportunidades = this.removePublicados(oportunidades)
						this.porcentagemSort(publicados)
						oportunidades.unshift(...publicados)

						this.$store.commit(mutationTypes.STOP_LOADING)

						return oportunidades					
					}catch(err){
						console.log(err)
						this.$store.commit(mutationTypes.STOP_LOADING)
						return []
					}	
				},
				async pegaSolicitacao(id){
					try{
						this.$store.commit(mutationTypes.START_LOADING)
						let resp = await ApiClientGo.oportunidadePorId(id)
						this.$store.commit(mutationTypes.STOP_LOADING)

						let solicitacao = resp.data.Solicitacao
						// Lista de espera
						solicitacao.ChamadaListaEspera ? solicitacao.ValorCaptado = solicitacao.Valor : ''
						// Encerrada
						solicitacao.Encerrado = solicitacao.StatusAnalise == "ENCERRADO" || this.diffDate(solicitacao.FimCaptacao) == "encerrado";
						// Score
						//solicitacao.Score = this.pegaScore(solicitacao)

						return solicitacao
					}catch(e){
						console.log(e)
						this.$store.commit(mutationTypes.STOP_LOADING)
						return null
					}
				},

			// Interacao Modal
				setCards(){
					sessionStorage.setItem('showCards', true)
					this.showCards=sessionStorage.getItem('showCards');
				},
				unsetCards(){
					sessionStorage.setItem('showCards', '')
					this.showCards=sessionStorage.getItem('showCards');
				},
				async mudarOportunidade(item) {
					this.solicitacao = await this.pegaSolicitacao(item._id)
					this.solicitacao.Garantia = item.Garantia
					this.AbrirModal(true);
				},
				AbrirModal(isAbrir) {
					// função de ajuste emergencial no css
					isAbrir ? document.querySelector('.main-content').style.zIndex = 10 : document.querySelector('.main-content').style.zIndex = 2

					if (document.getElementsByTagName("main").length > 0) {
						if (isAbrir) document.getElementsByTagName("main")[0].style.zIndex = "50";
						else document.getElementsByTagName("main")[0].style.zIndex = "0";
					}

					this.showModal = isAbrir;
				},
				async voltar() {
					this.AbrirModal(false);
					this.oportunidades = await this.listaOportunidades();
				},

			// Filtro de oportunidade
				async scoreAll(e) {
					// FILTRO DE TODOS OS SCORES
					this.$store.commit(mutationTypes.START_LOADING);

					for(let score in this.strScoreFilter) {
						// Seleciona ou nao os checkbox das cores do filtros
						this.$refs[this.strScoreFilter[score].score].checked = e.target.checked
						// salva guarda os scores
						if(e.target.checked){
							this.arrFiltroScore = []
							this.arrScore.push(this.$refs[this.strScoreFilter[score].score].id)
						}else{
							this.arrFiltroScore.push(this.$refs[this.strScoreFilter[score].score].id)
							this.arrScore = []
						}
					}
					// Verifica qual valor
					// Se false - zera o filtro
					// Se true - volta todos os filtros
					this.arrFiltroScore = []
					if(e.target.checked) {
						// Request para pegar solicitacoes
						this.oportunidades = await this.listaOportunidades();
					} else {
						this.oportunidades = [];
					}

					this.$store.commit(mutationTypes.STOP_LOADING)
				},
				async scoreClick(e, scoreValue) {
					//Filtro individual
					let publicados = []
					if(e.target.checked) {
						this.arrFiltroScore = this.arrFiltroScore.filter(elemento => elemento != scoreValue)
						this.arrScore.push(scoreValue)
					} else {
						this.arrFiltroScore.push(scoreValue)
						this.arrScore = this.arrScore.filter(elemento => elemento != scoreValue)
					}

					this.arrFiltroScore.length < 7 ? this.oportunidades = await this.listaOportunidades() : this.oportunidades = []
				},
			// Paginacao
				async paginacao(rota){
					this.indexPage = rota + 1
					this.oportunidades = await this.listaOportunidades();
				},
			// Tratativa de dados
				TrataOportunidades(oportunidades) {
					for (let i = 0; i < oportunidades.length; i++) {
						let oportunidade = oportunidades[i]
						// Lista de espera
						oportunidade.ChamadaListaEspera ? oportunidade.ValorCaptado = oportunidade.Valor : ''
						// Encerrada
						oportunidade.Encerrado = oportunidade.StatusAnalise == "ENCERRADO" || this.diffDate(oportunidade.FimCaptacao) == "encerrado";
						// Score
						oportunidade.Score = this.pegaScore(oportunidade)
					}
					return oportunidades
				},
				pegaScore(item){
					if(item.Score === "AA" || item.Score === "HR") {
						return item.Score
					}else if(typeof item.Score != "undefined"){
						let spliter = item.Score.split("")
						return spliter[0]
					}
					return 'excessao'
				},
				removePublicados(arr){
					let remove = []
					for (let index = 0; index < arr.length; index++) {
						arr[index].StatusAnalise == 'PUBLICADO' && this.diffDate(arr[index].FimCaptacao) != "encerrado" ? remove.unshift(index) : ''
					}
					remove.forEach(element => {
						arr.splice(element,1)
					});
					return arr
				},
				pegaPublicados(arr){
					let publicado = []
					for(let i=0; i < arr.length; i++) {
						if(arr[i].StatusAnalise == 'PUBLICADO' && this.diffDate(arr[i].FimCaptacao) != "encerrado"){
							let porcentagem = arr[i].ValorCaptado / arr[i].Valor * 100
							publicado.push({ ...arr[i], porcentagem })
						}
					}
					return publicado
				},
				porcentagemSort(arr) {
					let swapped;
					do {
						swapped = false;
						for (let i=0; i < arr.length-1; i++) {
							if (arr[i].porcentagem > arr[i+1].porcentagem) {
								let temp = arr[i];
								arr[i] = arr[i+1];
								arr[i+1] = temp;
								swapped = true;
							}
						}
					} while (swapped);
					return arr
				},

			// Metodos Modal
				diffDate(d2) {
					const miliSecs = (new Date(d2)) - (new Date())

					const diffDays = ( Number.parseInt(miliSecs / 1000 / 60 / 60 / 24) + 1 )

					if (diffDays <= 0) return "encerrado";

					return diffDays + " dias";
				},
				ajustIdOportunidade(id, qtd) {
					var s = String(id);
					while (s.length < (qtd || 2)) {
						s = "0" + s;
					}
					return s;
				},
				formatarScore(score) {
					if (score.length > 1 && !isNaN(score[1])) {
						return score[0];
					}

					return score;
				},
				formatarTipoEmprestimo(tipoEmprestimo) {
					if (tipoEmprestimo.toLowerCase() == "emprestimo-de-impacto2") {
						return "Impacto";
					}

					var splitedTipoEmprestimo = tipoEmprestimo.split('-');

					if (splitedTipoEmprestimo.length > 1) {
						if (splitedTipoEmprestimo[1] == "ccb")
							return splitedTipoEmprestimo[1].toUpperCase();

						return splitedTipoEmprestimo[1][0].toUpperCase() + splitedTipoEmprestimo[1].substr(1);
					}

					return tipoEmprestimo[0].toUpperCase() + tipoEmprestimo.substr(1);
				},
				money(n) {
					var c = 2,
						d = ",",
						t = ".",
						s = n < 0 ? "-" : "",
						i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c)))),
						j = (j = i.length) > 3 ? j % 3 : 0;
					return (
						s +
						(j ? i.substr(0, j) + t : "") +
						i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
						(c ?
							d +
							Math.abs(n - i)
							.toFixed(c)
							.slice(2) :
							"")
					);
				},
				inteiro(n) {
					return parseInt((n = Math.abs(Number(n) || 0).toFixed(2)));
				},
				levantado(oportunidade) {
					var val = (oportunidade.ValorCaptado / oportunidade.Valor) * 100 || 0.00;
					return val < 100.00 ? val : 100.00;
				},
				faltam(oportunidade) {
					var val = oportunidade.Valor - oportunidade.ValorCaptado;
					return val >= 0 ? val : 0;
				},
				valor(valor) {
					if (valor == null || valor == undefined) valor = 0;
					return this.money(valor);
				},
				templateRender(item) {
					if(typeof item.InicioCaptacao === "object"){
						item.InicioCaptacao  = item.InicioCaptacao.toISOString()
					}
					let separete = item.InicioCaptacao.split("T");
					let spliter  = separete[0].split("-");

					// Verifica qual é o template do perfil da empresa que sera renderizado
					// novo perfil a partir de 08/2018
					if((parseInt(spliter[0]) == 2018 && parseInt(spliter[1]) >= 8) || (parseInt(spliter[0]) > 2018)) {
						return '/investimentos/oportunidades/perfil-empresa/' + item._id+ "#" + this.indexPage;
					}

					return '/investimentos/oportunidades/perfil-empresa-old/' + item._id + "#" + this.indexPage
				},
				lowerCase(texto) {
					if (texto == null || texto == undefined) return "";

					if (texto == "AA" || texto == "HR") return texto.toLowerCase();

					return texto.substr(0, 1).toLowerCase();
				},
				InvestidorBloqueado() {
					if(this.investidor == null ||  this.investidor.Bloqueio == null  ||this.investidor.Bloqueio.FimBloqueio == null)
						return false;

					var  FimBloqueio= new Date(this.investidor.Bloqueio.FimBloqueio)

					return (FimBloqueio > (new Date()));
				},
			//tagueamento GA
			taggingGA() {
				this.$ga.page({
					page: '/oportunidades',
					title: 'Oportunidades',
				})
			},
		},
		components: {
			Modal,
			OpportunityCard,
			OpportunitiesList,
			Pagination
		},
		created: async function () {
			this.oportunidades = await this.listaOportunidades();

			try{
				document.querySelector('.main-content').style.zIndex = 2
			}catch(e){
				console.log(e)
			}

			this.$store.commit(mutationTypes.START_LOADING);
			
			this.User = this.$store.state.currentUser

			this.temSuitability = this.User.hassuitability == undefined ? false : this.User
				.hassuitability;
			this.temCadastroInvestidor = this.User.hasinvestor == undefined ? false : this.User
				.hasinvestor;

			if (this.User.investor == null)
				this.investidorAprovado = false;
			else
				this.investidorAprovado = this.User.investor.Status == "APROVADO" && this.temCadastroInvestidor;

			ApiClient.getInvestor()
				.then(investor => {
					this.bloqueio = investor.Bloqueio
					this.investidor = investor;
					this.InvestorAprovado = investor.Status == "APROVADO";
					this.$store.commit(mutationTypes.STOP_LOADING)
				})
				.catch(() => this.$store.commit(mutationTypes.STOP_LOADING));

			//tagueamento GA
			await this.taggingGA();
		},
	};
</script>

<style lang="scss" scoped>
	@import "../assets/styles/iouu/variables";
	@import "../assets/styles/iouu/mixins";

	.investment--select{
		z-index: 1;
		margin-bottom:-1.2em;
		transform: scaleY(0.85);
	}

	@media (min-width:1450px) {
		.investment--select{
			margin-bottom: -1.1em;
			transform: scaleY(1);
		}
	}

	.tit_page {
		h1 {
			@include xs {
				font-size: calcRem(25);
			}
		}

		.float-right {
			// padding-top: 1rem;
		}
	}

	.btn-modal {

		padding-top: 25px;

		.btn {
			padding:0px;
			margin:0px;
			border:none;
			padding-left: 30px;
			padding-right: 30px;
			line-height: 40px;
			text-transform: uppercase;
			font-weight: bold;
			@include font-size(16px);

		}

		@include xs {
			.btn {
				display: block;
				line-height: 35px;
				@include font-size(13px);

				&-primary {
					margin-bottom: 10px;
				}
			}
		}

		@include sm {
			.btn {
				display: block;
				line-height: 35px;
				@include font-size(13px);

				&-primary {
					margin-bottom: 10px;
				}
			}
		}

		@include ds {
			padding-top: 15px;

			.btn {
				line-height: 30px;
				padding-left: 20px;
				padding-right: 20px;
				@include font-size(13px);
			}
		}
	}

	table {
		border: none !important;
		th,
		td {
			text-align: center; // MEDIA max: 1199px
			@include brkp-01(1199px) {
				font-size: calcRem(12);
			}

			&:nth-child(1) {
				@include brkp-01(991px) {}
			}

			&:nth-child(2) {
				@include brkp-01(991px) {
					display: none;
				}
			}

			&:nth-child(3) {
				// MEDIA max: 1199px
				@include brkp-01(1199px) {
					display: none;
				}
			}

			&:nth-child(4) {
				@include brkp-01(991px) {
					width: 140px;
				}
			}

			&:nth-child(5) {
				@include brkp-01(991px) {
					width: 80px;
				}

				@include sm {
					display: none;
				}

				@include xs {
					display: none;
				}
			}

			&:nth-child(6) {
				// MEDIA max: 1199px
				@include brkp-01(1199px) {
					width: 135px;
				}

				@include sm {
					display: none;
				}

				@include xs {
					display: none;
				}
			}

			&:nth-child(7) {
				@include brkp-01(991px) {
					display: none;
				}
			}

			&:nth-child(8) {
				@include brkp-01(991px) {

					br {
						display: none;
					}

					a {
						&.btn-primary {
							font-size: calcRem(10);
							padding: .25rem .5rem;
							width: 112px;
						}

						&.btn-secondary {
							font-size: calcRem(10);
							padding: .25rem .5rem;
							width: 112px;
						}

						&.btn-link {
							width: 100%;
						}
					}
				}

				@include xs {
					& {
						width: 135px;
					}
				}
			}

		}

		th {
			border-top: none;
		}

		tr {
			border-bottom: 1px solid #e9ecef !important;
		}

		td {
			color: #666;
		}

		p {
			margin: 0px;
			padding: 0px;
			&.small {
				color: #888;
				font-size: 12px;
				font-weight: normal;
				line-height: 16px;
				padding-top: 5px;
			}
		}

		.rating {
			.score {
				display: inline-block;
				width: 40px;
				height: 40px;
				padding: 0px;
				border-radius: 50%;
				line-height: 40px;
				font-weight: bold;
				color: #fff;
				text-transform: uppercase; // MEDIA max: 991px
				@include brkp-01(991px) {
					width: 25px;
					height: 25px;
					line-height: 25px;
				}
			}
		}
	}

	.btn {
		&-primary {
			background: $btn-invest;
			font-weight: bold;
			text-transform: uppercase;
			border: none;
			padding-left: 20px;
			padding-right: 20px;
			&:hover {
				background: darken($btn-invest, 5%);
			} // MEDIA max: 1199px
			@include brkp-01(1199px) {
				font-size: calcRem(12);
			}
		}

		&-link {
			color: #666;
			&:hover {
				color: #999;
				text-decoration: underline !important;
			} // MEDIA max: 1199px
			@include brkp-01(1199px) {
				font-size: calcRem(12);
			}
		}
	}

	.tit {
		border: none !important;
		float: left;
		margin-top: 0px !important;
		margin-bottom: 0px !important;
		padding-bottom: 0px !important;

		h2 {
			font-size: 30px !important;
			margin-right: 20px;
		}

		.rating {
			position: relative;
			top: -2px !important;
		}

		small {
			display: inline-block;
			font-size: 15px !important;
			padding-top: 10px;
		}
	}

	.items {
		.margin {
			border-right: 1px solid #ddd;
			padding-right: 30px;
		}

		.item {
			border-bottom: 1px solid #ddd;
			padding: 15px 0;
			&__info {
				color: #888;
				@include font-size(16px);
				strong {
					color: #000;
				}
			}

			span {
				margin: 0;
				padding: 0;
			}

			&:first-child {
				padding-top: 0px;
			}

			&:last-child {
				border-bottom: none;
				padding-bottom: 0px;
			}

			p {
				padding: 0px;
				margin: 0px;
				color: #888;
				strong {
					color: #000;
				}
			}

			.progress {
				height: 18px!important;
				margin: 10px 0;
			}

			.small {
				font-size: 14px;
				color: #888;
				margin: 0px;
				padding: 0px;
			}

			form {
				margin-bottom: 20px;
			}

			.confirm {
				margin: 20px 0;
				img {
					width: 40px;
					display: block;
					margin-top: 6px;
					margin-right: 10px;
				}

				p {
					display: table;
					a {
						color: #888;
						text-decoration: underline !important;
						font-weight: bold;
						&:hover {
							color: #666;
						}
					}
				}
			}

			.alert {
				.btn {
					margin-top: 0px;
				}
				a:hover {
					color: #856404;
				}
			}

			a {
				&.item__link {
					float: left;
					@include font-size(22px);
					line-height: 30px;
					color: #888;
					position: relative;
					&:hover {
						color: $c3;
					}
					@include xs {
						@include font-size(18px);
					}
				}

				i {
					background: url(/static/assets/images/ico-separador.svg) no-repeat right center;
					background-size: 8px;
					width: 20px;
					line-height: 30px;
					position: absolute;
					top: 0;
					right: -20px;

					@include xs {
						background-size: 6px;
						width: 18px;
						line-height: 30px;
					}
				}
			}

			.form-row {
				label {
					color: #000 !important;
					padding-bottom: 10px;
				}

				input {
					margin-bottom: 0px;
					box-shadow: none !important;
					height: 50px;
				}

				button {
					height: 50px;
					@include font-size(18px);
				}
			}
		}
	}

	.btn-link {
		padding: 0px;
	} // ESTILO PARA DESKTOP
	@include ds {

		.tit_page {

			h1 {
				@include font-size(25px);
				margin: 0px;
				padding: 0px;
			}

			.float-right {
				padding-top: 8px;
			}
		}

		table {

			th {
				@include font-size(13px);
			}

			td {
				@include font-size(13px);
			}

			p {
				&.small {
					font-size: 10px;
					line-height: 8px;
				}
			}

			.rating {
				.score {
					width: 30px;
					height: 30px;
					border-radius: 50%;
					line-height: 30px;
				}
			}
		}

		.progress {
			height: 15px;
			font-size: 8px;
			line-height: 8px;
		}

		.btn {
			@include font-size(13px);
			text-transform: uppercase;
			font-weight: bold;

			&-primary {
				padding: 6px 15px;
			}
			&-danger {
				padding: 6px 15px;
			}
		} // MODAL
		.tit {

			h2 {
				font-size: 18px !important;
			}
			small {
				font-size: 12px !important;
				padding-top: 5px;
			}
		}


		.box {
			padding: 10px;
		}

		.items {

			.item {
				padding: 10px 0;

				.small {
					font-size: 10px;
				}

				&__info {
					@include font-size(10px);
				}

				a {
					&.item__link {
						@include font-size(14px);
						line-height: 20px;
					}

					i {
						background-size: 5px;
						width: 11px;
						line-height: 20px;
						top: 0;
						right: -15px;
					}
				}

				label {
					font-size: 9px !important;
					padding-bottom: 5px;
				}


				.form-row {

					input {
						@include font-size(16px);
						height: 40px;
					}

					button {
						height: 40px;
						@include font-size(14px);
					}

				}

				.alert {
					h2 {
						background: none;
						padding: 0px;
						font-size: 18px;
					}

					p {
						padding-bottom: 10px;
					}

					.btn {
						width: 80% !important;
						margin: 0 10%;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/ListOpportunities.vue